import { render, staticRenderFns } from "./sidemenu_instagram.vue?vue&type=template&id=5de8bcc3&"
import script from "./sidemenu_instagram.vue?vue&type=script&lang=js&"
export * from "./sidemenu_instagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports